import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Reveal } from "../components/motion";
import { POLICIES } from "../lib/policies";

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!policy) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-6 pt-24 text-center px-5">
        <h1 className="font-display font-extrabold uppercase tracking-tighter text-4xl">PAGE NOT FOUND</h1>
        <Link to="/" className="bg-bone text-ink font-mono text-xs tracking-[0.2em] px-8 py-4 hover:bg-ember hover:text-white transition-colors" data-testid="policy-404-home-button">
          BACK HOME
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-[860px] mx-auto px-5 md:px-10 pt-40 md:pt-48 pb-24 md:pb-36">
      <Reveal>
        <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] text-ash uppercase mb-4">
          {policy.source === "verbatim" ? "Our policies" : "Our policies"}
        </p>
        <h1 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-4xl sm:text-5xl" data-testid="policy-title">
          {policy.title}
        </h1>
        <p className="font-mono text-[10px] md:text-[11px] tracking-[0.15em] text-ash uppercase mt-4">
          Last updated: {policy.updated}
          {policy.source === "draft" && <span className="text-ember"> — pending owner review</span>}
        </p>
      </Reveal>

      <div className="mt-12 space-y-10" data-testid="policy-body">
        {policy.sections.map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 0.03, 0.2)}>
            <section>
              {s.heading && (
                <h2 className="font-display font-bold uppercase tracking-tight text-lg md:text-xl mb-4">{s.heading}</h2>
              )}
              <div className="space-y-3">
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="text-ash text-sm leading-relaxed">{p}</p>
                ))}
              </div>
              {s.bullets && (
                <ul className="mt-4 space-y-2.5">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-3 text-ash text-sm leading-relaxed">
                      <span className="text-ember mt-[3px] shrink-0">+</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap gap-4 font-mono text-[10px] tracking-[0.18em] uppercase text-ash">
        {POLICIES.filter((p) => p.slug !== policy.slug).map((p) => (
          <Link key={p.slug} to={`/policies/${p.slug}`} className="hover:text-bone transition-colors" data-testid={`policy-crosslink-${p.slug}`}>
            {p.title}
          </Link>
        ))}
      </div>
    </div>
  );
}
